import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";

export const serviceTypeApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getServiceTypeList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.serviceType }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getServiceTypeById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.serviceType }/${ id }`,
		method: 'GET',
	  }),
	}),

	addServiceType: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.serviceType }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editServiceType: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.serviceType }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteServiceType: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.serviceType }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddServiceTypeMutation,
  useDeleteServiceTypeMutation,
  useEditServiceTypeMutation,
  useGetServiceTypeByIdQuery,
  useGetServiceTypeListQuery,
  useLazyGetServiceTypeListQuery
} = serviceTypeApi;
